<script setup lang="ts">
  import { MpLoadingContainer, MpText } from '@borg/ui';

  definePageMeta({
    middleware: ['info-pages'],
  });

  const route = useRoute();
  const slug = route.params.slug as string;

  const { data, pending, error, refresh } = await infoPagesRepository.get(slug);

  const pageTitle = computed(() => data.value?.title ?? '');
  const description = computed(() => data.value?.description ?? '');
  const content = computed(() => data.value?.content);

  // Format the title with ' | MojPosao' suffix
  const config = useRuntimeConfig();
  const siteName = (config.public.project as any)?.title || (config.public.project as any)?.name || 'MojPosao';
  const title = computed(() => {
    if (pageTitle.value) {
      return `${pageTitle.value} | ${siteName}`;
    }
    return siteName;
  });

  useHead({
    title: title,
    meta: [{ name: 'description', content: description }],
  });

  useSeoMeta({
    ogTitle: title,
    ogDescription: description,
  });

  function onReload() {
    refresh();
  }
</script>
<template>
  <MpLoadingContainer
    :is-loading="pending"
    :has-error="error"
    @reload="onReload"
  >
    <LayoutGrid>
      <MpText
        v-if="pageTitle"
        as="h1"
      >
        {{ pageTitle }}
      </MpText>
      <MpText
        v-if="data && data.subtitle"
        as="h3"
      >
        {{ data.subtitle }}
      </MpText>
      <GeneratedPage :content="content" />
    </LayoutGrid>
  </MpLoadingContainer>
</template>
